import {ApplicationConfig, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {PreloadAllModules, provideRouter, withPreloading} from '@angular/router';
import {routes} from './app.routes';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {HttpClientModule, provideHttpClient} from "@angular/common/http";
import {loginTokenInterceptorProvider, unauthorizedInterceptorProvider} from "./interceptor/interceptors";
import {tokenProviders} from "./tokens/tokens";
import {provideToastr} from 'ngx-toastr';
import {registerLocaleData} from '@angular/common';
import localeIn from '@angular/common/locales/en-IN';

registerLocaleData(localeIn);

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAnimationsAsync(),
    loginTokenInterceptorProvider,
    unauthorizedInterceptorProvider,
    importProvidersFrom(HttpClientModule),
    tokenProviders,    
    provideToastr(
      {
        timeOut: 2500,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
        closeButton: true,
        tapToDismiss: true,
        progressBar: true
      }
    ),
  ]
};
